import React from "react";
import { Icon } from "./components/Icon";

export const hasIconOnly = (children: React.ReactNode): boolean => {
  const childrenArray = React.Children.toArray(children);

  return (
    childrenArray.length === 1 &&
    childrenArray.some((c) => React.isValidElement(c) && c.type === Icon)
  );
};
